export default {
  buttonStyle: {
    margin: "0 1rem 0 1rem",
  },
};
